// extracted by mini-css-extract-plugin
export default {"header":"Header_header__O7m0l","inner":"Header_inner__Pc+UR","link":"Header_link__kDgde"};